import { render } from "./NewDomain.vue?vue&type=template&id=61f5e3fa"
import script from "./NewDomain.vue?vue&type=script&lang=js"
export * from "./NewDomain.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__